import { format } from 'date-fns'
import { dateWithTime } from 'constants/dateFormats'

export const convertToExcel = (data) => {
  return data.map((item) => {
    let targetEvent
    if (item?.triggerDTO?.eventDTO) {
      const { tournamentDTO, startTime } = item.triggerDTO.eventDTO
      const matchStartTime = format(new Date(startTime), dateWithTime)
      targetEvent = `${tournamentDTO.tournamentName} ${matchStartTime}`
    }
    const { contributors } = item

    return {
      'InWin id': item.id,
      Status: item.state || '-',
      Trigger: item.triggerDTO.description || '-',
      Amount: item.amount || '-',
      Contributors: item.contributorsAmount || '-',
      'Contributors Name':
        contributors.length > 0 ? contributors[0].email : '-',
      Created: format(new Date(item.date), dateWithTime),
      'Target Event': targetEvent || '-',
      'Target Beneficiary': item.beneficiaryDTO.beneficiaryName || '-',
    }
  })
}

export const filterConverter = (fromData, toData) => {
  let from
  let to
  if (fromData) {
    from = {
      operator: '>=',
      value: fromData,
    }
  }
  if (toData) {
    to = {
      operator: '<=',
      value: toData,
    }
  }
  return { from, to }
}
